import React, {PropTypes} from "react";
import {connect} from 'react-redux';
import FeedbackSmileys from './feedbackSmileys';
import FeedbackTextArea from './feedbackTextArea';
import FeedbackRadio from './feedbackRadio';


class FeedbackContainer extends React.Component {
	  constructor(props) {
    		super(props);
      this.state={active: 0};

		  }


    getInputTypeHelper(input){

    	switch (input.questionType){
    		case 'TEXT_AREA':
    			return <FeedbackTextArea {...input} />
    			break;
    		case 'RADIO':
    			return <FeedbackRadio {...input} />
    			break;
    		case 'SMILEY':
    			return <FeedbackSmileys {...input} active = {this.props.smileyId} onChange = {this.props.onSmileyChange}  />
    			break;
    		default:
    			return;
    	}
    }

    getInputElements(){
    	let inputs = [];
    	let smilyInput = []
    	console.log(inputs);
		for (const key of Object.keys(this.props.inputs)) {
			  let inputElement = this.getInputTypeHelper(this.props.inputs[key]);
		      if(this.props.inputs[key].questionType == 'SMILEY'){
		      	smilyInput.push(inputElement);
		      }else{
		      	inputs.push(inputElement);
		      }
		    }
		return {inputs,smilyInput};
    }

	render() {


		let {inputs,smilyInput} = this.getInputElements();
		return (
				<div>
					{smilyInput}
	                    <div className="full-form step-2 text-center">
	                        <div className="bgColor">
                            {this.props.smileyActive?inputs: null}
	                        </div>

	                        <div className="submitBtn">
	                            <input
                                disabled={!this.props.smileyActive}
                                className="btn btn-primary btn-lg btn-block"  type="submit" value="Submit Feedback" />
	                         </div>
                        </div>
                </div>
                    );
	}
}
export default FeedbackContainer;



/** WEBPACK FOOTER **
 ** ./src/feature/feedback/feedbackContainer.js
 **/